import React from "react";
import Grid from "@mui/material/Grid";

import DashboardMenuEach from "./DashboardMenuEach";
import { useTranslation } from "react-i18next";

const LeftMenu = ({ cursor }) => {
  const { t, i18n } = useTranslation();
  return (
    <Grid md={3} sm={12} item>
      <DashboardMenuEach
        menu={t("Orders")}
        link="/dashboard"
        cursor={cursor === "dashboard" ? true : false}
      />
      <DashboardMenuEach
        link="/dashboard-personal"
        menu={t("Personal Information")}
        cursor={cursor === "personal" ? true : false}
      />
      <DashboardMenuEach
        link="/dashboard-address"
        menu={t("Manage Your Address")}
        cursor={cursor === "address" ? true : false}
      />
      <DashboardMenuEach
        link="/dashboard-password"
        menu={t("Change Password")}
        cursor={cursor === "password" ? true : false}
      />

      {window.sessionStorage.getItem("block") ? null : (
        <DashboardMenuEach
          link="/dashboard-review"
          menu={t("My Reviews")}
          cursor={cursor === "review" ? true : false}
        />
      )}

      <DashboardMenuEach
        link="/dashboard-support"
        menu={t("Request A Support")}
        cursor={cursor === "support" ? true : false}
      />
    </Grid>
  );
};

export default LeftMenu;
